'use client';

import { useStorageState } from '@brand/utils';
import { useLayoutEffect, useMemo, type JSX } from 'react';
import {
  QUIZ_SCORE_STORAGE_KEY,
  QUIZ_VIEW_STORAGE_KEY,
  QuizState,
} from './quiz.const';
import { QuizEmailView } from './views/quiz-email/quiz-email.view';
import { QuizGameView } from './views/quiz-game/quiz-game.view';
import { QuizViewIdle } from './views/quiz-idle/quiz-idle.view';
import { QuizResultView } from './views/quiz-result/quiz-result.view';

type TQuizProps = {
  onFinish(score: number): void;
};
export const Quiz = ({ onFinish }: TQuizProps): JSX.Element => {
  const [score, setScore] = useStorageState(
    0,
    QUIZ_SCORE_STORAGE_KEY,
    'session',
  );

  const [quizState, setQuizState] = useStorageState<QuizState>(
    QuizState.IDLE,
    QUIZ_VIEW_STORAGE_KEY,
    'session',
  );

  useLayoutEffect(() => {
    if (quizState === QuizState.RESULT) {
      onFinish(score);
    }
  }, []);

  const views = useMemo(
    () => ({
      [QuizState.IDLE]: (
        <QuizViewIdle onStart={() => setQuizState(QuizState.GAME)} />
      ),
      [QuizState.GAME]: (
        <QuizGameView
          onFinish={(result: number) => {
            setScore(result);
            setQuizState(QuizState.EMAIL);
          }}
        />
      ),
      [QuizState.EMAIL]: (
        <QuizEmailView
          onSuccess={() => {
            setQuizState(QuizState.RESULT);
            onFinish(score);
          }}
        />
      ),
      [QuizState.RESULT]: <QuizResultView score={score} />,
    }),
    [score, onFinish],
  );

  return views[quizState];
};
